import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCatalog } from "@/lib/useCatalog";
import { SearchBar } from "@/components/SearchBar";
import { ProviderCard } from "@/components/ProviderCard";
import { CategoryIcon } from "@/components/CategoryIcon";
import { PageLoader } from "@/components/layout/RequireAuth";
import { EmptyState } from "@/pages/CategoryPage";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const city = params.get("kota") || "";
  const { cities } = useCatalog();
  const [result, setResult] = useState(null);

  useEffect(() => {
    setResult(null);
    api.get("/search", { params: { q, city: city || undefined } }).then((r) => setResult(r.data));
  }, [q, city]);

  return (
    <div className="container-page py-12" data-testid="search-page">
      <div className="max-w-3xl">
        <SearchBar key={`${q}-${city}`} cities={cities} initialQ={q} initialCity={city} testPrefix="search-page" />
      </div>
      <h1 className="mt-10 text-3xl font-bold tracking-tight text-stone-900" data-testid="search-title">
        Hasil untuk "{q}"{city && cities.length ? ` di ${cities.find((c) => c.slug === city)?.name || city}` : ""}
      </h1>
      {result === null ? <PageLoader /> : (
        <>
          <section className="mt-8">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-stone-500">Jenis jasa ({result.categories.length})</h2>
            <div className="mt-4 flex flex-wrap gap-3" data-testid="search-category-results">
              {result.categories.length === 0 && <p className="text-sm text-stone-500">Tidak ada jenis jasa yang cocok.</p>}
              {result.categories.map((c) => (
                <Link key={c.slug} to={`/kategori/${c.slug}`} data-testid={`search-category-${c.slug}`}
                  className="card-soft card-lift flex items-center gap-3 px-4 py-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-teal-50 text-teal-700"><CategoryIcon name={c.icon} className="h-4 w-4" /></span>
                  <span className="text-sm font-semibold text-stone-800">{c.name}</span>
                </Link>
              ))}
            </div>
          </section>
          <section className="mt-12">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-stone-500">Penyedia ({result.providers.length})</h2>
            <div className="mt-4">
              {result.providers.length === 0 ? (
                <EmptyState testId="search-empty" title="Penyedia tidak ditemukan" desc="Coba kata kunci lain, misalnya “AC”, “catering”, atau “renovasi”." />
              ) : (
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="search-provider-results">
                  {result.providers.map((p) => <ProviderCard key={p.slug} provider={p} />)}
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </div>
  );
}
